package com.daytimegaming.ourdailyfinances.presentation.home

import com.daytimegaming.ourdailyfinances.domain.model.Transaction
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow

enum class SpendingRange(val displayName: String, val days: Int) {
    SevenDays("7D", 7),
    OneMonth("1M", 30),
    ThreeMonths("3M", 90),
    SixMonths("6M", 180),
    OneYear("YR", 365),
    YearToDate("YTD", -1)
}

val excludedPrimaryCategories = setOf("INCOME", "LOAN_DISBURSEMENTS", "TRANSFER_IN", "TRANSFER_OUT")
val excludedDetailedCategories = setOf("LOAN_PAYMENTS_CREDIT_CARD_PAYMENT")

fun Transaction.isExcludedFromSpending(): Boolean {
    val primary = activeCategory?.primary ?: category.firstOrNull() ?: ""
    val detailed = activeCategory?.detailed ?: ""
    if (primary in excludedPrimaryCategories) return true
    if (detailed in excludedDetailedCategories) return true
    if (category.any { cat -> cat.equals("Credit Card", ignoreCase = true) || cat.equals("Credit Card Payment", ignoreCase = true) }) return true
    return false
}

fun Transaction.getRecentSpendingCategoryBreakdownKey(): String {
    val primary = activeCategory?.primary ?: category.firstOrNull() ?: ""
    val detailed = activeCategory?.detailed ?: category.firstOrNull() ?: ""

    val cleanPrimary = primary.trim()
    val cleanDetailed = detailed.trim()

    val remaining = if (cleanPrimary.isNotEmpty() && cleanDetailed.startsWith(cleanPrimary)) {
        val suffix = cleanDetailed.removePrefix(cleanPrimary).removePrefix("_")
        if (suffix.isNotEmpty()) suffix else cleanPrimary
    } else {
        if (cleanDetailed.isNotEmpty()) cleanDetailed else "General"
    }

    return remaining.split("_", " ")
        .filter { it.isNotEmpty() }
        .joinToString(" ") { word ->
            word.lowercase().replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() }
        }
}

class RecentSpendingManager {
    private val _selectedRange = MutableStateFlow(SpendingRange.OneMonth)
    val selectedRange = _selectedRange.asStateFlow()

    fun setRange(range: SpendingRange) {
        _selectedRange.value = range
    }
}
